import initSqlJs from 'sql.js/dist/sql-wasm.js'
import { fetchBundledSeedBytes, fetchSqliteBytes, persistSqliteBytes } from './r2-sync'

let db = null
let SQL = null
let ready = false
let persistTimer = null
let dirty = false

export function isDbReady() {
  return ready
}

export function getDb() {
  if (!db) throw new Error('SQLite 尚未初始化')
  return db
}

function rowsToObjects(result) {
  if (!result?.length) return []
  const { columns, values } = result[0]
  return values.map((row) =>
    Object.fromEntries(columns.map((c, i) => [c, row[i]])),
  )
}

export function queryAll(sql, params = []) {
  const stmt = getDb().prepare(sql)
  stmt.bind(params)
  const rows = []
  while (stmt.step()) rows.push(stmt.getAsObject())
  stmt.free()
  return rows
}

export function queryOne(sql, params = []) {
  return queryAll(sql, params)[0] ?? null
}

export function run(sql, params = []) {
  getDb().run(sql, params)
  markDirty()
}

export function markDirty() {
  dirty = true
  schedulePersist()
}

function schedulePersist() {
  if (persistTimer) clearTimeout(persistTimer)
  persistTimer = setTimeout(() => {
    persistTimer = null
    persistNow().catch((err) => console.warn('[db] R2 persist failed:', err.message))
  }, 800)
}

export async function persistNow() {
  if (!db || !dirty) return
  const bytes = db.export()
  await persistSqliteBytes(bytes)
  dirty = false
}

export async function initDatabase() {
  if (ready) return db
  SQL = await initSqlJs({
    locateFile: (file) => `/${file}`,
  })

  let bytes = await fetchSqliteBytes()
  if (!bytes?.length) {
    bytes = await fetchBundledSeedBytes()
    dirty = true
  }

  db = new SQL.Database(bytes)
  ready = true

  if (dirty) {
    try {
      await persistNow()
    } catch {
      // first seed upload may fail in local dev without PUT middleware
    }
  }

  return db
}

export function writeAudit(userId, action, payload) {
  run(
    `INSERT INTO fb_audit_logs (user_id, action, ip_address, payload) VALUES (?, ?, ?, ?)`,
    [userId, action, 'browser', JSON.stringify(payload ?? {})],
  )
}
